module.exports = __webpack_public_path__ + "9e2866fe5d4944eb82cf94399aabcf07.svg";